import React from 'react';
import { Grid } from 'semantic-ui-react';
import './styles.css';

function StorySection({ imageUrl, title, text, orientation = 'left' }) {
  return (
    <div className="story-section-container">
      <Grid stackable className="story-section-grid">
        <Grid.Row className="story-section-row">
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <div className={`story-section-layout ${orientation === 'right' ? 'reversed' : ''}`}>
              {/* Imagen rotada con efecto "foto pegada" */}
              <div className="story-section-image-wrapper">
                <div
                  className="story-section-image"
                  style={{
                    backgroundImage: `url(${imageUrl})`
                  }}
                />
              </div>
              
              {/* Texto superpuesto con fondo semi-transparente */}
              <div className="story-section-text-overlay">
                <div className="story-section-text-content">
                  <div className="story-section-text">
                    {text}
                  </div>
                </div>
              </div>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
}

export default StorySection;
